/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment } from 'react';
import { node, shape } from 'prop-types';
import 'styles/Layout.scss';

const Row = ({
  style,
  children,
  ...rest
}) => (
  <div style={style} className="layout-row" {...rest}>
    {children}
  </div>
);

Row.defaultProps = {
  children: <Fragment />,
  style: {},
};

Row.propTypes = {
  style: shape({}),
  children: node,
};

export default Row;
